import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_USERS: GlameraIconDefinition = {
  name: 'users',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-users-body" d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <path class="glm-users-side-arc" d="M16 3.128a4 4 0 0 1 0 7.744"></path>
    <path class="glm-users-side-arc" d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
    <circle class="glm-users-head" cx="9" cy="7" r="4"></circle>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-users-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './users.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UsersIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_USERS;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
